<div class="cond-list" [class.cond-list--active]="active()">
  <div class="cond-list__head">
    <button
      type="button"
      role="switch"
      class="cond-list__switch"
      [class.cond-list__switch--on]="active()"
      [attr.data-testid]="'condition-switch-' + scopeId()"
      [attr.aria-checked]="active()"
      [attr.aria-label]="'tdb.condition.toggleAria' | translate"
      [disabled]="disabled()"
      (click)="toggle()"
    >
      <span class="cond-list__thumb" aria-hidden="true"></span>
    </button>
    <span class="cond-list__label">{{ 'tdb.condition.toggle' | translate }}</span>
    @if (!active()) {
      <span class="cond-list__always">{{ 'tdb.condition.alwaysRuns' | translate }}</span>
    }
  </div>

  @for (row of conditions(); track $index; let k = $index) {
    <div class="cond-list__row">
      @if (k > 0) {
        <span class="cond-list__and" [attr.data-testid]="'condition-and-' + scopeId() + '-' + (k + 1)">
          {{ 'tdb.condition.and' | translate }}
        </span>
      }
      <app-step-condition-editor
        class="cond-list__editor"
        [override]="row"
        [scopeId]="scopeId() + '-' + (k + 1)"
        [listMode]="true"
        [library]="library()"
        [disabled]="disabled()"
        (changed)="update(k, $event)"
      />
      <button
        type="button"
        class="cond-list__remove"
        [attr.data-testid]="'condition-remove-' + scopeId() + '-' + (k + 1)"
        [attr.aria-label]="'tdb.condition.remove' | translate: { n: k + 1 }"
        [disabled]="disabled()"
        (click)="remove(k)"
      >
        <span aria-hidden="true">×</span>
      </button>
    </div>
  }

  @if (active()) {
    <div class="cond-list__foot">
      <button
        type="button"
        class="cond-list__add"
        [attr.data-testid]="'condition-add-' + scopeId()"
        [disabled]="disabled() || full()"
        (click)="add()"
      >
        {{ 'tdb.condition.addAnd' | translate }}
      </button>
      @if (full()) {
        <span class="cond-list__max" [attr.data-testid]="'condition-max-' + scopeId()">
          {{ 'tdb.condition.maxReached' | translate: { max: max } }}
        </span>
      }
    </div>
    @if (complete()) {
      <p class="cond-list__skip" [attr.data-testid]="'condition-skip-hint-' + scopeId()">
        {{ (conditions().length > 1 ? 'tdb.condition.skipHintMany' : 'tdb.condition.skipHint') | translate }}
      </p>
    }
  }
</div>
